module.exports = __webpack_public_path__ + "static/media/jambes.6c9e070f.jpg";